import axios from 'axios'
const url = process.env.REACT_APP_NEW_BASE_V4_URL_MONITORING
const NEWurl = process.env.REACT_APP_NEW_BASE_V4_URL_MONITORING
const NEW_URL_AUTH = process.env.REACT_APP_NEW_BASE_V4_URL_AUTH
const URL_CORE = process.env.REACT_APP_NEW_BASE_V4_URL_CORE

const LOGIN = 'auth/login'
const CHANGEPassword = 'users/change-password'
const NEWPLANT = 'plant'
const UPDATEPLANT = 'plant/plant/'
const DELETEPLANT = 'plant/'
const DEVICE = 'equipment/devicetypes'
const TECHGRAPH = 'plant/graph/graph-data?plantId='
const HOMEGRAPH = 'plant/graph/graph-data/'
const NOTIFICATIONALL = 'notifications/faulty?plantId=all'
const NOTIFICATIONBYPLANT = 'notifications/faulty?plantId='

export const BREVO_API_KEY =
  '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'

export const expressURL = process.env.REACT_APP_NEW_BASE_V4_URL_MONITORING?.replace(/\/$/, '')

// export const expressURL = 'htt'

const NEWTECHGRAPH = 'analytics/graph-v2/'
const NEWAVGGRAPH = 'analytics/graph-v2/aggregated/'

const homegraph = 'analytics/graph-v2/aggregated/'

// Create axios instance with default config
export const axiosInstance = axios.create()

// Add auth token to requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Add response interceptor for token refresh
let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

export const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem('refreshToken')

    if (!refreshToken) {
      throw new Error('No refresh token available')
    }

    const response = await axios.post(NEW_URL_AUTH + 'refresh', {
      refreshToken: refreshToken
    })

    const { accessToken, refreshToken: newRefreshToken } = response.data

    localStorage.setItem('accessToken', accessToken)
    if (newRefreshToken) {
      localStorage.setItem('refreshToken', newRefreshToken)
    }

    return accessToken
  } catch (error) {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('user')
    localStorage.removeItem('userType')
    localStorage.removeItem('userId')
    localStorage.removeItem('Authorised')
    // Let the app handle the redirect based on auth state change or reload
    window.location.href = '/login'
    throw error
  }
}

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const originalRequest = error.config

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject })
        })
          .then((token) => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token
            return axiosInstance(originalRequest)
          })
          .catch((err) => {
            return Promise.reject(err)
          })
      }

      originalRequest._retry = true
      isRefreshing = true

      try {
        const accessToken = await refreshAccessToken()
        axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken
        originalRequest.headers['Authorization'] = 'Bearer ' + accessToken
        processQueue(null, accessToken)
        return axiosInstance(originalRequest)
      } catch (err) {
        processQueue(err, null)
        return Promise.reject(err)
      } finally {
        isRefreshing = false
      }
    }

    return Promise.reject(error)
  }
)

export const login = async (params) => {
  try {
    const response = await axios.post(url + LOGIN, {
      email: params.email,
      password: params.password,
    })
    return response.data
  } catch (error) {
    return error
  }
}



export const ChangePassword = async (params) => {
  try {
    const response = await axiosInstance.post(
      url + CHANGEPassword,
      {
        userId: params.userId,
        oldPassword: params.oldPassword,
        newPassword: params.newPassword,
      }
    )
    return response
  } catch (error) {
    return error
  }
}

export const Createnewplant = async (params) => {
  try {
    const response = await axiosInstance.post(url + NEWPLANT, params)
    return response
  } catch (error) {
    return error
  }
}
export const FetchPlantList = async (params, Order) => {
  try {
    const response = await axiosInstance.get(
      url + NEWPLANT + `?date=${params}&plantSizeOrder=${Order}`
    )

    return response
  } catch (error) {
    return error
  }
}

export const FetchPlantSearch = async (date, name, type, Order) => {
  try {
    const response = await axiosInstance.get(
      url +
      NEWPLANT +
      `?date=${date}&plantNameSearch=${name}&plantType=${type}&plantSizeOrder=${Order}`
    )

    return response
  } catch (error) {
    return error
  }
}

export const Updatenewplant = async (params) => {
  try {
    const response = await axiosInstance.put(
      url + UPDATEPLANT + params?.Id,
      params?.values
    )
    return response
  } catch (error) {
    return error
  }
}

export const Deletenewplant = async (params) => {
  try {
    const response = await axiosInstance.delete(url + DELETEPLANT + params)
    return response
  } catch (error) {
    return error
  }
}

export const FetchDeviceList = async () => {
  try {
    const response = await axiosInstance.get(url + DEVICE)
    return response
  } catch (error) {
    return error
  }
}

export const FetchTechnicalGraph = async (params) => {
  try {
    const response = await axiosInstance.get(
      url + TECHGRAPH + params + '&yieldOrEtodayOrEnergyM=etoday'
    )
    return response
  } catch (error) {
    return error
  }
}
export const FetchYeildGraph = async (params) => {
  try {
    const response = await axiosInstance.get(
      url + TECHGRAPH + params + '&yieldOrEtodayOrEnergyM=yield'
    )
    return response
  } catch (error) {
    return error
  }
}
export const FetchEnergyMGraph = async (params) => {
  try {
    const response = await axiosInstance.get(
      url + TECHGRAPH + params + '&yieldOrEtodayOrEnergyM=energyM'
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchGraphBysort = async (
  PlantID,
  technicalDate,
  sortType,
  graphType,
  token
) => {
  try {
    const response = await axiosInstance.get(
      url +
      TECHGRAPH +
      PlantID +
      `&yieldOrEtodayOrEnergyM=${graphType}&fromDate=${technicalDate}&period=${sortType}&id=all`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchPRGraphBysort = async (
  PlantID,
  technicalDate,
  sortType,
  graphType,
  token
) => {
  try {
    const response = await axiosInstance.get(
      url +
      `graph/graph-data?fromDate=${technicalDate}&period=${sortType}&resultType=PR&plantId=${PlantID}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchHomePRGraphBysort = async (
  technicalDate,
  sortType,
  graphType,
  token
) => {
  try {
    const response = await axiosInstance.get(
      url +
      `graph/graph-data?fromDate=${technicalDate}&period=${sortType}&resultType=PR`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchPRGraphByID = async (
  PlantID,
  technicalDate,
  sortType,
  graphType,
  deviceID,
  token
) => {
  try {
    const response = await axiosInstance.get(
      url +
      `graph/graph-data?fromDate=${technicalDate}&period=${sortType}&plantId=${PlantID}&resultType=PR&deviceId=${deviceID}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchHomeGTIGraphBysort = async (
  technicalDate,
  sortType,
  devtype,
  token
) => {
  try {
    const response = await axiosInstance.get(
      url +
      `graph/graph-data?fromDate=${technicalDate}&period=${sortType}&resultType=${devtype}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchGraphByminimumguarantee = async (
  PlantID,
  technicalDate,
  token,
  duration
) => {
  try {
    const response = await axiosInstance.get(
      url +
      NEWPLANT +
      '/graph/minimum-guarantee-per-month?id=' +
      PlantID +
      `&period=${duration}&fromDate=${technicalDate}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchGraphByInverterguarantee = async (
  PlantID,
  technicalDate,
  token,
  duration
) => {
  try {
    const response = await axiosInstance.get(
      url +
      NEWPLANT +
      '/graph/inverter-guarantee-per-month?id=' +
      PlantID +
      `&period=${duration}&fromDate=${technicalDate}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchGraphByExpectedGen = async (
  PlantID,
  technicalDate,
  token,
  duration
) => {
  try {
    const response = await axiosInstance.get(
      url +
      NEWPLANT +
      '/graph/expected-generation?plantId=' +
      PlantID +
      `&period=${duration}&fromDate=${technicalDate}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchGraphBYid = async (
  PlantID,
  technicalDate,
  sortType,
  graphType,
  devId,
  token
) => {
  try {
    const response = await axiosInstance.get(
      url +
      TECHGRAPH +
      PlantID +
      `&yieldOrEtodayOrEnergyM=${graphType}&fromDate=${technicalDate}&period=${sortType}&id=${devId}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchGhiGraphBYid = async (
  PlantID,
  technicalDate,
  sortType,
  graphType,
  token
) => {
  try {
    const response = await axiosInstance.get(
      url +
      `plant/graph/graph-data-ghi?yieldOrEtodayOrEnergyM=${graphType}&fromDate=${technicalDate}&period=${sortType}&plantId=${PlantID}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchHomeGraph = async (
  technicalDate,
  sortType,
  graphType,
  token
) => {
  try {
    const response = await axiosInstance.get(
      url +
      HOMEGRAPH +
      `all?yieldOrEtodayOrEnergyM=${graphType}&fromDate=${technicalDate}&period=${sortType}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchPlantCountGraph = async (technicalDate, sortType, token) => {
  try {
    const response = await axiosInstance.get(
      url +
      NEWPLANT +
      `/graph/plants-per-month?fromDate=${technicalDate}&period=${sortType}`
    )
    return response
  } catch (error) {
    return error
  }
}
export const FetchPlantSizeGraph = async (technicalDate, sortType, token) => {
  try {
    const response = await axiosInstance.get(
      url +
      NEWPLANT +
      `/graph/plantsize-per-month?fromDate=${technicalDate}&period=${sortType}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchDashboarddata = async (userId, token) => {
  try {
    const response = await axiosInstance.get(url + NEWPLANT + `/dashboard/stats`)
    return response
  } catch (error) {
    return error
  }
}

export const Addlogdta = async (data, token) => {
  // console.log(token, "token----token")
  try {
    const response = await axiosInstance.post(url + NEWPLANT + '/log', data)
    return response
  } catch (error) {
    return error
  }
}

export const Getlogdta = async (token) => {
  try {
    const response = await axiosInstance.get(url + NEWPLANT + '/log/getAllLog')
    return response
  } catch (error) {
    return error
  }
}

export const GetlogPlant = async (plantName, token) => {
  try {
    const response = await axiosInstance.get(url + NEWPLANT + `/getLog/${plantName}`)
    return response
  } catch (error) {
    return error
  }
}

export const GetMonthlyReport = async (plantId, token, fromDate, toDate) => {
  try {
    const response = await axiosInstance.get(
      url +
      NEWPLANT +
      `/report-v2/getMonthlyReport/${plantId}/${fromDate}/${toDate}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const GetMonthlyInvoice = async (plantId, token, fromDate, toDate) => {
  try {
    const response = await axiosInstance.get(
      url +
      NEWPLANT +
      `/report-v2/getTaxInvoice/${plantId}/${fromDate}/${toDate}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const GetUserLogReport = async (plantId, token, fromDate, toDate) => {
  try {
    const response = await axiosInstance.get(url + `logs`)
    return response
  } catch (error) {
    return error
  }
}

export const GetUserLogReportByFilter = async (token, fromDate, toDate) => {
  try {
    const response = await axiosInstance.get(
      url + `logs?fromDate=${fromDate}&toDate=${toDate}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchDeviceStatus = async (plantId, token) => {
  try {
    const response = await axiosInstance.get(url + `plant/device-status/${plantId}`)
    return response
  } catch (error) {
    return error
  }
}

export const FetchIrradianceGraphByID = async (
  PlantID,
  technicalDate,
  sortType,
  graphType,
  token
) => {
  try {
    const response = await axiosInstance.get(
      url +
      `graph/graph-data?fromDate=${technicalDate}&period=${sortType}&plantId=${PlantID}&resultType=IRRADIATION`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchAllNotification = async (token) => {
  try {
    const response = await axiosInstance.get(
      url + NOTIFICATIONALL
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchNotificationByPlant = async (plantId) => {
  try {
    const response = await axiosInstance.get(
      url + NOTIFICATIONBYPLANT + plantId
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchUsersList = async (token) => {
  try {
    const response = await axiosInstance.get(
      url + `users?role=client&limit=10&offset=0`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchInternalUsersList = async (token) => {
  try {
    const response = await axiosInstance.get(
      url + `users?role=sub_admin&limit=10&offset=0`
    )
    return response
  } catch (error) {
    return error
  }
}

export const AddExternalUser = async (data, token) => {
  try {
    const response = await axiosInstance.post(url + 'users', data)
    return response
  } catch (error) {
    return error
  }
}

export const AddInternalUser = async (data, token) => {
  try {
    const response = await axiosInstance.post(url + 'users', data)
    return response
  } catch (error) {
    return error
  }
}

export const AddPlantToUser = async (data, token) => {
  // console.log(token, "token----token")
  try {
    const response = await axiosInstance.post(url + 'users/plant/add', data)
    return response
  } catch (error) {
    return error
  }
}

export const DeleteUser = async (userId, token) => {
  try {
    const response = await axiosInstance.delete(url + `users/${userId}`)
    return response
  } catch (error) {
    return error
  }
}

export const RemovePlantToUser = async (data, token) => {
  try {
    const response = await axiosInstance.post(url + 'users/plant/remove', data)
    return response
  } catch (error) {
    return error
  }
}

// new API changes

export const FetchGraphBysortNew = async (
  PlantID,
  fromDate,
  sortType,
  graphType,
  token,
  toDate,
  roofID,
  deviceID
) => {
  try {
    const response = await axiosInstance.get(
      NEWurl +
      NEWTECHGRAPH +
      PlantID +
      `/${graphType}/${fromDate}/${sortType}/${roofID}/${toDate}/${deviceID}`
    )

    return response
  } catch (error) {
    console.log(error, 'err')
    return error
  }
}

export const fetchInverterEnergyData = async (
  plantId,
  startDate,
  endDate,
  duration,
  type
) => {
  console.log(
    'Inverter Energy Data:',
    plantId,
    startDate,
    endDate,
    duration,
    type
  )
  try {
    const url = `${process.env.REACT_APP_NEW_BASE_V4_URL_MONITORING}api/inverterquarterhourlydata/plant/${plantId}`
    // const url = `https://staging-backend-v3-express.de.energy/api/inverterquarterhourlydata/plant/${plantId}`

    const response = await axiosInstance.get(url, {
      params: {
        startDate: startDate,
        endDate: endDate,
        duration: duration,
        type: type,
      },
    })

    return response
  } catch (error) {
    console.error('Error fetching inverter energy data:', error)
    throw new Error('Failed to fetch inverter energy data')
  }
}

export const fetchEnergyMeterData = async (
  plantId,
  startDate,
  endDate,
  duration,
  type
) => {
  try {
    const url = `${process.env.REACT_APP_NEW_BASE_V4_URL_MONITORING}api/energyMeterQuarterHourly/searchByPlantId`
    // const url = `https://staging-backend-v3-express.de.energy/api/energyMeterQuarterHourly/searchByPlantId`

    const response = await axiosInstance.get(url, {
      params: {
        plantId,
        startDate: startDate,
        endDate: endDate,
        duration: duration,
        type: type,
      },
    })

    return response
  } catch (error) {
    console.error('Error fetching energy meter data:', error)
    return error
  }
}

// Function to fetch GHI data
export const fetchGHIData = async (
  plantId,
  startDate,
  endDate,
  duration,
  type
) => {
  try {
    // const baseUrl = 'https://staging-backend-v3-express.de.energy' // Fixed URL (added colon instead of space and a port number if needed)
    const baseUrl = process.env.REACT_APP_NEW_BASE_V4_URL_MONITORING?.replace(/\/$/, '')
    const url = `${baseUrl}/api/ghiQuarterHourlyData/byPlantIdAndTimeRange?plantId=${plantId}&startTime=${encodeURIComponent(
      startDate
    )}&endTime=${encodeURIComponent(endDate)}&duration=${duration}&type=${type}`

    const response = await axiosInstance.get(url)

    return response.data
  } catch (error) {
    console.error('Error fetching GHI data:', error)
    throw error
  }
}

// Function to fetch GTI data
export const fetchGTIData = async (
  plantId,
  startDate,
  endDate,
  duration,
  type
) => {
  try {
    // const baseUrl = 'https://staging-backend-v3-express.de.energy' // Fixed URL (added colon instead of space and a port number if needed)
    const baseUrl = process.env.REACT_APP_NEW_BASE_V4_URL_MONITORING?.replace(/\/$/, '')
    const url = `${baseUrl}/api/gtiquarterhourlydata/plant?plantId=${plantId}&startDate=${encodeURIComponent(
      startDate
    )}&endDate=${encodeURIComponent(endDate)}&duration=${duration}&type=${type}`

    const response = await axiosInstance.get(url)
    //console.log("FetchGTIData:", response.data)

    return response.data
  } catch (error) {
    console.error('Error fetching GTI data:', error)
    throw error
  }
}

export const FetchHomeAvgGraphBysortNew = async (
  fromDate,
  sortType,
  graphType,
  token,
  toDate,
  deviceId
) => {
  try {
    const response = await axiosInstance.get(
      NEWurl +
      NEWAVGGRAPH +
      `${graphType}/${fromDate}/${sortType}/all/${toDate}/${deviceId}`
    )
    return response
  } catch (error) {
    return error
  }
}

// ==========================================
// Master Data Management APIs (Roles, Orgs, Entities)
// ==========================================

export const FetchRoles = async (token) => {
  try {
    const response = await axiosInstance.get(NEW_URL_AUTH + 'roles')
    return response
  } catch (error) {
    return error
  }
}

export const FetchPermissions = async (params, token) => {
  try {
    const { page = 1, limit = 30, ...filters } = params
    const queryString = new URLSearchParams({
      page,
      limit,
      ...filters,
    }).toString()

    const response = await axiosInstance.get(NEW_URL_AUTH + `permissions?${queryString}`)
    return response
  } catch (error) {
    return error
  }
}

export const CreateRole = async (data, token) => {
  try {
    const response = await axiosInstance.post(NEW_URL_AUTH + 'roles', data)
    return response
  } catch (error) {
    return error
  }
}

export const FetchOrganizations = async (token) => {
  try {
    const response = await axiosInstance.get(URL_CORE + 'organizations')
    return response
  } catch (error) {
    return error
  }
}

export const CreateOrganization = async (data, token) => {
  try {
    const response = await axiosInstance.post(URL_CORE + 'organizations', data)
    return response
  } catch (error) {
    return error
  }
}

export const FetchDepartments = async (token) => {
  try {
    const response = await axiosInstance.get(URL_CORE + 'organizations/departments/list')
    return response
  } catch (error) {
    return error
  }
}

export const FetchEntities = async (token) => {
  try {
    const response = await axiosInstance.get(URL_CORE + 'entities')
    return response
  } catch (error) {
    return error
  }
}

export const CreateEntity = async (data, token) => {
  try {
    const response = await axiosInstance.post(URL_CORE + 'entities', data)
    return response
  } catch (error) {
    return error
  }
}




export const FetchAggregatedYieldAndGti = async (
  startDate,
  duration,
  type,
  token,
  endDate = 'all'
) => {
  try {
    let apiDuration
    switch (duration) {
      case '1m':
        apiDuration = '1M'
        break
      case '3m':
        apiDuration = '3M'
        break
      case '6m':
        apiDuration = '6M'
        break
      case 'year':
        apiDuration = '1Y'
        break
      case 'ytd':
        apiDuration = 'YTD'
        break
      case 'custom':
        apiDuration = 'CUST'
        break
      case 'mtd':
        apiDuration = 'MTD'
        break
      default:
        apiDuration = '1M'
    }
    // const baseUrl = 'https://staging-backend-v3-express.de.energy' // Fixed URL (added colon instead of space and a port number if needed)
    const baseUrl = 'https://staging-backend-v3-express.de.energy'
    const response = await axiosInstance.get(
      `${baseUrl}/api/gtiquarterhourlydata/getAggregatedYieldAndGti?startDate=${startDate}&duration=${apiDuration}&type=${type}&endDate=${endDate}`
    )

    const data = response.data
    console.log(`Received ${data.length} data points for ${type}`)
    return { data }
  } catch (error) {
    console.error('Error fetching aggregated data:', error)
    return { data: [] }
  }
}

// export const FetchPlantListNew = async (params, token, Order) => {
//   try {
//     const newdate = `${params}T00:00:00+05:30`
//     const encodedDate = encodeURIComponent(newdate)
//     const response = await axios.get(
//       NEWurl + `api/plant?date=${encodedDate}&plantSizeOrder=${Order}`,
//       { headers: { Authorization: `Bearer ${token}` } }
//     )

//     return response
//   } catch (error) {
//     return error
//   }
// }

export const FetchPlantListNew = async (params, token, Order, isMonitoring = true, page = 1, limit = 1000) => {
  try {
    const newdate = `${params}T00:00:00+05:30`
    const encodedDate = encodeURIComponent(newdate)
    const response = await axiosInstance.get(
      NEWurl + `plants?date=${encodedDate}&plantSizeOrder=${Order}&isMonitoring=${isMonitoring}&page=${page}&limit=${limit}`
    )

    console.log('FetchPlantListNew response:', response)

    return response
  } catch (error) {
    return error
  }
}

export const FetchPlantSearchNew = async (date, name, type, token, Order, isMonitoring = true, page = 1, limit = 25) => {
  try {
    const newdate = `${date}T00:00:00+05:30`
    const encodedDate = encodeURIComponent(newdate)
    const response = await axiosInstance.get(
      NEWurl +
      `plants?date=${encodedDate}&plantNameSearch=${name}&plantType=${type}&plantSizeOrder=${Order}&isMonitoring=${isMonitoring}&page=${page}&limit=${limit}`
    )

    return response
  } catch (error) {
    return error
  }
}

export const FetchPlantByID = async (params, token, Order, plantId) => {
  try {
    const newdate = `${params}T00:00:00+05:30`


    const encodedDate = encodeURIComponent(newdate)


    const response = await axiosInstance.get(
      NEWurl +
      `plants?date=${encodedDate}&plantSizeOrder=${Order}&plantId=${plantId}`
    )

    return response
  } catch (error) {
    return error
  }
}

export const CreatenewplantNew = async (params, token) => {
  try {
    console.log('add Plat')

    const response = await axiosInstance.post(NEWurl + 'plants', params)
    return response
  } catch (error) {
    return error
  }
}

export const DeletenewplantNew = async (params, token) => {
  try {
    const response = await axiosInstance.delete(NEWurl + 'plants/' + params)
    return response
  } catch (error) {
    return error
  }
}
export const UpdatenewplantNew = async (params) => {
  try {
    const response = await axiosInstance.put(
      NEWurl + 'plants/' + params?.Id,
      params?.values
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchSensorListNew = async (token) => {
  try {
    const response = await axiosInstance.get(NEWurl + 'api/sensors')
    return response
  } catch (error) {
    return error
  }
}

export const FetchPlantCountGraphNew = async (
  technicalDate,
  sortType,
  token,
  toDate
) => {
  try {
    const response = await axiosInstance.get(
      NEWurl +
      'api' +
      `/graph/plants-per-month?fromDate=${technicalDate}&period=${sortType}&toDate=${toDate}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchPlantSizeGraphNew = async (
  technicalDate,
  sortType,
  token,
  toDate
) => {
  try {
    const response = await axiosInstance.get(
      NEWurl +
      'api' +
      `/graph/plant-sizes-per-month?fromDate=${technicalDate}&period=${sortType}&toDate=${toDate}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchGraphByminimumguaranteeNew = async (
  PlantID,
  technicalDate,
  token,
  duration,
  TechnicalTodate
) => {
  try {
    const response = await axiosInstance.get(
      NEWurl +
      'api' +
      '/graph/minimum-guarantee-per-month?id=' +
      PlantID +
      `&period=${duration}&fromDate=${technicalDate}&toDate=${TechnicalTodate}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchDashboarddataNew = async (userId, token) => {
  try {
    const response = await axiosInstance.get(NEWurl + 'plants/plantsummry')
    return response
  } catch (error) {
    return error
  }
}

export const FetchGraphByInvesterguaranteeNew = async (
  PlantID,
  technicalDate,
  token,
  duration,
  TechnicalTodate
) => {
  try {
    const response = await axiosInstance.get(
      NEWurl +
      'api' +
      '/graph/investor-guarantee-per-month?id=' +
      PlantID +
      `&period=${duration}&fromDate=${technicalDate}&toDate=${TechnicalTodate}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const loginNew = async (params) => {
  console.log(params, 'login params')
  try {
    const URL_CORE = process.env.REACT_APP_NEW_BASE_V4_URL_AUTH + 'login'
    const response = await axios.post(URL_CORE, {
      email: params.email,
      password: params.password,
    })
    console.log(response, 'login response')
    // Return raw data directly - Login.jsx handles the structure
    return response.data
  } catch (error) {
    return error
  }
}

export const FetchDeviceStatusNew = async (plantId, token) => {
  try {
    const response = await axiosInstance.get(
      NEWurl + `plants/${plantId}/device-status`
    )

    console.log('FetchDeviceStatusNew response:', response)

    return response
  } catch (error) {
    return error
  }
}

export const AddInternalUserNew = async (data, token) => {
  try {
    //temporarily set organisationID in front-end, move to backend service in future if needed
    let organizationId = null
    try {
      const orgResponse = await axiosInstance.get(NEWurl + 'organizations')
      const organizations =
        orgResponse?.data?.data || orgResponse?.data || []
      const deOrg = Array.isArray(organizations)
        ? organizations.find((org) => org.organizationCode === 'DE')
        : null

      if (deOrg) {
        organizationId = deOrg._id?.$oid || deOrg._id || deOrg.id
      }
    } catch (orgError) {
      console.error(
        'Failed to fetch organizations for internal user creation:',
        orgError
      )
    }

    const payload = { ...data }
    if (organizationId) {
      payload.organizationId = organizationId
    }

    const response = await axiosInstance.post(NEW_URL_AUTH + 'users', payload)
    return response
  } catch (error) {
    return error
  }
}

export const FetchUsersListNew = async (token, type = 'client') => {
  try {
    //normalising
    const formattedType = type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();

    const response = await axiosInstance.get(
      NEW_URL_AUTH + `users`,
      {
        params: {
          userType: 'external',
          'metadata[externalUserType]': formattedType,
          limit: 10,
        }
      }
    )

    return response
  } catch (error) {
    return error
  }
}

export const FetchInternalUsersListNew = async (token) => {
  try {
    const response = await axiosInstance.get(
      NEW_URL_AUTH + `users?limit=10`
    )
    return response
  } catch (error) {
    return error
  }
}

export const AddExternalUserNew = async (data, token) => {
  try {
    const response = await axiosInstance.post(NEW_URL_AUTH + 'users', data)
    return response
  } catch (error) {
    return error.response
  }
}

export const FetchUserByIdNew = async (userId, token) => {
  try {
    const response = await axiosInstance.get(NEW_URL_AUTH + `users/${userId}`)
    return response
  } catch (error) {
    return error
  }
}

export const UpdateUserNew = async (userId, data, token) => {
  try {
    const response = await axiosInstance.put(NEW_URL_AUTH + `users/${userId}`, data)
    return response
  } catch (error) {
    return error
  }
}

export const DeleteUserNew = async (userId, token) => {
  try {
    const response = await axiosInstance.delete(NEW_URL_AUTH + `users/${userId}`)
    return response
  } catch (error) {
    return error
  }
}

export const RemovePlantToUserNew = async (data, token) => {
  console.log(token, 'token----token')
  try {
    const response = await axiosInstance.delete(NEWurl + 'api/users/plant', {
      data: data,
    })
    return response
  } catch (error) {
    return error
  }
}

export const AddPlantToUserNew = async (data, token) => {
  try {
    const response = await axiosInstance.post(NEWurl + 'api/users/plant', data)
    return response
  } catch (error) {
    return error
  }
}

export const FetchDeviceListNew = async (token) => {
  try {
    const response = await axiosInstance.get(NEWurl + 'api/device-types-v2')
    return response
  } catch (error) {
    return error
  }
}

export const GetMonthlyInvoiceNew = async (
  plantId,
  token,
  fromDate,
  toDate
) => {
  try {
    const response = await axios.get(
      // NEWurl +
      // `http://localhost:6500/api/report-v2/getTaxInvoice/${plantId}/${fromDate}/${toDate}`,
      `https://staging-backend-v3-monitoring.de.energy/api/report-v2/getTaxInvoice/${plantId}/${fromDate}/${toDate}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const AddlogdtaNew = async (data, token) => {
  try {
    const postData = {
      ...data,
      duration: Array.isArray(data.timePeriods)
        ? data.timePeriods.join(' | ')
        : data.duration,
      multiplyingFactor: Number(data.multiplyingFactor) || undefined,
    }

    const response = await axiosInstance.post(
      NEWurl + 'api/demed-generation-logs',
      postData
    )
    return response
  } catch (error) {
    return error
  }
}

// Updated API function
export const UpdateLogDta = async (logId, data, token) => {
  try {
    const putData = {
      ...data,
      duration: Array.isArray(data.timePeriods)
        ? data.timePeriods.join(' | ')
        : data.duration,
      multiplyingFactor: Number(data.multiplyingFactor) || undefined,
    }

    const response = await axiosInstance.put(
      NEWurl + `api/demed-generation-logs/${logId}`,
      putData
    )
    console.log('response.data', response)

    return response
  } catch (error) {
    return error
  }
}

export const GetlogdtaNew = async (token) => {
  try {
    const response = await axiosInstance.get(NEWurl + 'api/demed-generation-logs')
    return response
  } catch (error) {
    return error
  }
}

export const DeleteLogDta = async (logId, token) => {
  try {
    const response = await axiosInstance.delete(
      NEWurl + `api/demed-generation-logs/${logId}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const GetlogPlantNew = async (plantName, token) => {
  try {
    const response = await axiosInstance.get(
      NEWurl + `api/demed-generation-logs/${plantName}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const GetMonthlyReportNew = async (plantId, token, fromDate, toDate) => {
  try {
    const response = await axiosInstance.get(
      NEWurl +
      `api/report-v2/getMonthlyReport/${plantId}/${fromDate}/${toDate}`
    )
    return response
  } catch (error) {
    return error
  }
}

export const GetUserLogReportNew = async (token) => {
  try {
    console.log(token, 'token for the system logs')
    const response = await axiosInstance.get(NEWurl + `api/system-logs`)
    return response
  } catch (error) {
    return error
  }
}

export const GetUserLogReportByFilterNew = async (token, fromDate, toDate) => {
  try {
    const response = await axiosInstance.get(
      NEWurl +
      `api/system-logs?fromDate=${fromDate}&toDate=${toDate}&limit=10&offset=0`
    )
    return response
  } catch (error) {
    return error
  }
}

export const ChangePasswordNew = async (params, token) => {
  try {
    const response = await axiosInstance.put(
      NEW_URL_AUTH + 'users/me/password',
      {
        currentPassword: params.oldPassword,
        newPassword: params.newPassword,
        confirmPassword: params.confirmPassword,
      }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchAllNotificationNew = async (token) => {
  try {
    const response = await axiosInstance.get(
      NEWurl + 'api/notifications/faulty?plantId=all'
    )
    return response
  } catch (error) {
    return error
  }
}

export const ClearAllNotificationNew = async (token, userId) => {
  try {
    const response = await axiosInstance.patch(
      NEWurl + 'api/notifications/clear-all-faulty',
      {
        userId: userId,
      }
    )
    return response
  } catch (error) {
    return error
  }
}

export const FetchNotificationByPlantNew = async (plantId) => {
  try {
    const response = await axiosInstance.get(
      NEWurl + 'api/notifications/faulty?plantId=' + plantId
    )
    return response
  } catch (error) {
    return error
  }
}

export const ForgotPassword = async (params) => {
  try {
    const response = await axios.post(NEWurl + 'api/users/forgot-password', {
      email: params.email,
    })
    return response
  } catch (error) {
    return error
  }
}

export const getAutomationStatus = async (plantId) => {
  try {
    const token = localStorage.getItem('accessToken')
    const response = await fetch(
      `https://staging-backend-v3-express.de.energy/api/invoices/email/automation/${plantId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` })
        },
      }
    )

    if (!response.ok) {
      throw new Error('Failed to fetch automation status')
    }

    const data = await response.json()
    console.log('isAutomated,', data)

    return data.data.automation
  } catch (error) {
    console.error('Error fetching automation status:', error)
    return error
  }
}

export const updateAutomationStatus = async (plantId, newStatus) => {
  try {
    const token = localStorage.getItem('accessToken')
    const response = await fetch(
      'https://staging-backend-v3-express.de.energy/api/invoices/email/automation',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { Authorization: `Bearer ${token}` })
        },
        body: JSON.stringify({
          plantId: plantId,
          automation: newStatus,
        }),
      }
    )

    if (!response.ok) {
      throw new Error('Network response was not ok')
    }

    const data = await response.json()
    console.log('Success:', data)
  } catch (error) {
    console.error('Error:', error)
  }
}

export const FetchActivePowerData = async (
  plantId,
  startDate,
  endDate,
  duration,
  token
) => {
  if (duration === 'day') {
    duration = 'today'
  }
  // const baseUrl = 'https://staging-backend-v3-express.de.energy' // Fixed URL (added colon instead of space and a port number if needed)
  const baseUrl = 'https://staging-backend-v3-express.de.energy'
  let url = `${baseUrl}/api/activepower/?plantId=${plantId}&type=ActivePower`
  if (duration === 'cust') {
    url += `&startDate=${startDate}&endDate=${endDate}&duration=cust`
  } else {
    url += `&startDate=${startDate}&duration=${duration}`
  }

  const response = await axiosInstance.get(url)

  if (response.status !== 200) {
    throw new Error('Network response was not ok')
  }

  return response.data
}

export const fetchGraphV2Data = async (
  plantId,
  dataType,
  fromDate,
  period,
  token,
  roofId = 'all',
  toDate = 'all',
  deviceId = 'all'
) => {
  try {
    // Validate token before making the request
    if (!token || token.trim() === '') {
      console.error('Token is empty or undefined')
      throw new Error('Authentication token is missing or invalid')
    }

    //const url = `http://localhost:6500/api/graph-v2/${plantId}/${dataType}/${fromDate}/${period}/${roofId}/${toDate}/${deviceId}`
    //const url = `https://staging-backend-v3-express.de.energy/api/graph-v2/${plantId}/${dataType}/${fromDate}/${period}/${roofId}/${toDate}/${deviceId}`
    const url =
      NEWurl +
      `analytics/graph-v2/${plantId}/${dataType}/${fromDate}/${period}/${roofId}/${toDate}/${deviceId}`

    console.log('Fetching Graph V2 Data:', {
      url,
      dataType,
      period,
      fromDate,
      toDate,
      roofId,
      deviceId,
      tokenLength: token ? token.length : 0,
      tokenStartsWith: token ? token.substring(0, 20) + '...' : 'none',
    })

    const response = await axiosInstance.get(url, {
      headers: {
        'Content-Type': 'application/json',
      },
    })

    //console.log("fetchGrapbV2Data response:", response.data);

    return response.data
  } catch (error) {
    console.error('Unable to fetch Graph V2 data:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      url: error.config?.url,
    })
    throw error
  }
}

export const fetchPlantOpData = async (date, token, order, plantId) => {
  try {
    const formattedDate = `${date}T00:00:00+05:30`
    const encodedDate = encodeURIComponent(formattedDate)
    const response = await axiosInstance.get(
      NEWurl + `plants?date=${encodedDate}&plantSizeOrder=${order}&plantId=${plantId}`
    )
    return response
  } catch (error) {
    console.error('Unable to fetch plant operational data')
    throw error
  }
}

export const fetchGraphV2aggr = async (
  dataType,
  fromDate,
  period,
  token,
  toDate = 'all'
) => {
  try {
    const url = `${NEWurl}${homegraph}${dataType}/${fromDate}/${period}/${toDate}`;
    //const url = `http://localhost:6500/api/graph-v2/aggregated/${dataType}/${fromDate}/${period}/${toDate}`;
    const response = await axiosInstance.get(url)
    console.log('fetchGraphV2aggr response:', response.data)

    return response.data
  } catch (error) {
    console.error('Unable to fetch Graph V2 aggregated data:', error)
    throw error
  }
}

export const fetchPlantReportData = async (startDate, endDate) => {
  try {
    const response = await axiosInstance.get(
      `${expressURL}/plantreport?startDate=${startDate}&endDate=${endDate}`
    )
    if (response.data.success) {
      return { data: response.data.data, summary: response.data.summary }
    } else {
      throw new Error('API returned unsuccessful response')
    }
  } catch (error) {
    throw new Error(`Failed to fetch plant data: ${error.message}`)
  }
}

// Fetched Live Data - Real-time device information
export const FetchLiveDeviceData = async (plantId, deviceId, token) => {
  try {
    const response = await axiosInstance.get(
      NEWurl + `livedivicedata/fetched/${plantId}/${deviceId}`
    )
    console.log(`FetchLiveDeviceData (${deviceId}) response:`, response)
    return response.data
  } catch (error) {
    console.error(`Error fetching live device data for ${deviceId}:`, error)
    return {
      success: false,
      error: error.message || 'Failed to fetch live device data',
    }
  }
}

// Calculated Device Data - Historical calculated data comparing previous and current day
export const FetchCalculatedData = async (plantId, deviceId, token) => {
  try {
    const response = await axiosInstance.get(
      NEWurl + `livedivicedata/calculted/${plantId}/${deviceId}`
    )
    console.log(`FetchCalculatedData (${deviceId}) response:`, response)
    return response.data
  } catch (error) {
    console.error(`Error fetching calculated data for ${deviceId}:`, error)
    return {
      success: false,
      error: error.message || 'Failed to fetch calculated data',
    }
  }
}

// Batch fetch all live device data for a plant
export const FetchAllLiveDeviceData = async (plantId, token) => {
  try {
    const deviceIds = ['INV-001', 'SNS-001']
    const promises = deviceIds.map((deviceId) =>
      FetchLiveDeviceData(plantId, deviceId, token)
    )
    const results = await Promise.all(promises)

    return {
      success: true,
      data: {
        'INV-001': results[0],
        'SNS-001': results[1],
      },
    }
  } catch (error) {
    console.error('Error fetching all live device data:', error)
    return {
      success: false,
      error: error.message || 'Failed to fetch all live device data',
    }
  }
}

// Batch fetch all calculated data for a plant
export const FetchAllCalculatedData = async (plantId, token) => {
  try {
    const deviceIds = ['INV-001', 'INV-002', 'MTR-001']
    const promises = deviceIds.map((deviceId) =>
      FetchCalculatedData(plantId, deviceId, token)
    )
    const results = await Promise.all(promises)

    return {
      success: true,
      data: {
        'INV-001': results[0],
        'INV-002': results[1],
        'MTR-001': results[2],
      },
    }
  } catch (error) {
    console.error('Error fetching all calculated data:', error)
    return {
      success: false,
      error: error.message || 'Failed to fetch all calculated data',
    }
  }
}

// Fetch all calculated inverters for a plant
export const FetchCalculatedInvertersForPlant = async (plantId, token) => {
  try {
    const response = await axiosInstance.get(
      NEWurl + `livedivicedata/calculated/inverters/${plantId}`
    )
    console.log('FetchCalculatedInvertersForPlant response:', response)
    return response.data
  } catch (error) {
    console.error('Error fetching calculated inverters for plant:', error)
    return {
      success: false,
      error: error.message || 'Failed to fetch calculated inverters',
    }
  }
}

// Fetch all live inverters data for a plant (real-time power monitoring)
export const FetchAllInvertersLiveData = async (plantId, token) => {
  try {
    const response = await axiosInstance.get(
      NEWurl + `livedivicedata/fetched/${plantId}/ALL-INVERTERS`
    )
    console.log('FetchAllInvertersLiveData response:', response)
    return response.data
  } catch (error) {
    console.error('Error fetching all inverters live data:', error)
    return {
      success: false,
      error: error.message || 'Failed to fetch all inverters live data',
    }
  }
}
